import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import { safeHTML } from '../../../utils/safeHTML';
import useStateControls from '../../../hooks/useStateControls';
import { useRequestsHandlerData } from '../../../hooks/useRequestsHandlerData';
import Icon from '../../baseComponents/gui/icon/Icon';
import classNames from 'classnames';
import { useTranslation } from '../../../translations';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import AppLoader from '../../features/appLoader/AppLoader';

const QuizStartModal = React.forwardRef(function QuizStartModal(
  { title, description, image: img, button, isBought, cost, goToQuiz, onClose, type, ...props },
  ref,
) {
  const { closeModal, id } = useModal();
  const stateControls = useStateControls();
  const { setState } = useStateControls();

  const [xp, attempts] = ['score', 'attempts'].map?.((key) => (props?.customAwards ?? {})?.[key]);

  const isBoughtSettings = !isBought ? { count: cost, coins: 'main/coins' } : {};
  const { t } = useTranslation();

  const close = () => {
    onClose?.();
    closeModal({ id });
  };

  const onClick = () => {
    ({
      info() {
        goToQuiz();
        closeModal({ id });
      },
      default: goToQuiz,
    })[type ?? 'default']?.();
  };

  const isPending = useRequestsHandlerData([
    {
      address: 'requestsGameBuyQuiz',
      fulfilled: () => {
        closeModal({ type: 'all' });
        stateControls[button?.callback](button?.callbackOptions);
        setState('quiz');
      },
    },
  ]);

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']} closeOnOverlayClick={false}>
      <div className={classNames('quiz-start-modal', { [`quiz-start-modal_${type}`]: type })} ref={ref}>
        <div className='quiz-start-modal__bg' />
        <div className='quiz-start-modal__content'>
          <div className='quiz-start-modal__image'>
            <img src={img} alt={title} />
          </div>
          <h2 className='quiz-start-modal__title'>{safeHTML(t(title))}</h2>
          <p className='quiz-start-modal__text'>{safeHTML(t(description))}</p>

          {(attempts || xp) && (
            <div className={'quiz-start-modal__awards'}>
              {attempts && (
                <div className='quiz-start-modal__attempts'>
                  <div className='quiz-start-modal__attempts-icon'>
                    <Icon name={'energy-g'} />
                  </div>
                  <div className='quiz-start-modal__attempts-title'>{safeHTML(`+${attempts}`)}</div>
                </div>
              )}
              {xp && (
                <div className='buy-modal__hp'>
                  <div className='buy-modal__hp-title'>{safeHTML(`+${xp}XP`)}</div>
                  <div className='buy-modal__hp-text'>{safeHTML(t('other.toRating'))}</div>
                </div>
              )}
            </div>
          )}
          <CustomButton
            {...({ info: {} }[type] ?? isBoughtSettings)}
            className={'custom-button custom-button_price quiz-start-modal__button'}
            text={button?.text}
            onClick={onClick}
          />
        </div>
      </div>
      {isPending && <AppLoader />}
    </CustomModal>
  );
});
export default QuizStartModal;
QuizStartModal.propTypes = {};
